import { DesignerToolsHeadingTableCell } from "./DesignerToolsHeadingTableCell";
import { GeneratedTableColumn } from "./GeneratedTableColumn";
import { Table } from "./Table";
import { TableColumnProps } from "./TableColumnProps";

export class DesignerToolsTableColumn extends GeneratedTableColumn {
    constructor(props?: Partial<TableColumnProps>) {
        super(props);
        this.headingDef = this.createHeadingCell();
        this.cellDef = this.createCellDef(this.table);
    }

    private createHeadingCell(): DesignerToolsHeadingTableCell {
        const result = new DesignerToolsHeadingTableCell({ table: this.table });
        return result;
    }

    private createCellDef(table: Table): any {
        return {
            def: {
                cellProps: { table },
                type: "designertoolscell"
             }
        };
    }
}
